import styled from "styled-components";
import { Scrollable } from "../../../../../common/styles";
import colors from "../../../../../config/colors";

export const TaskMembersContainer = styled.div`
  width: 100%;
  max-height: 70vh;
  ${Scrollable}
  padding: 0 20px;
  box-sizing: border-box;
  @media (max-width: 992px) {
   padding: 0;
    width: calc(100vw - 103px);
    margin: 0 auto;
  }
}
`;

export const TaskMembersTable = styled.div`
  max-width: 100%;
  ${Scrollable};
  margin: 0 20px;
`;
export const MemberRow = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${colors.secondary};
  @media (max-width: 767px) {
    width: 700px;
    box-sizing: border-box;
  }
`;
export const MemberInfo = styled.div`
  display: flex;
  align-items: center;
  width: 210px;
  @media (max-width: 767px) {
    width: 340px;
  }
`;
export const MemberImage = styled.img`
  height: 40px;
  width: 40px;
  object-fit: cover;
  border-radius: 50%;
  opacity: ${(props) => props.disabled && "0.5"};
`;
export const MemberName = styled.div`
  color: ${(props) => (props.color ? colors.primary : "")};
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 10px;
  display: flex;
  gap: 7px;
`;
export const Span = styled.span`
  display: block;
`;
export const MemberActions = styled.div`
  display: flex;
  align-items: center;
  margin: 0 20px;
  @media (max-width: 767px) {
    width: 470px;
    box-sizing: border-box;
  }
`;
export const Container = styled.div`
  position: relative;
  display: inline-block;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.7);
  color: red;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AddEditModalHeader = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-bottom: none;
  padding: 20px 20px 0;
  span > div {
    padding: 0;
    border: 0;
  }
`;

export const HeaderRow = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 9px 9px 9px 9px;
  border-radius: 5px 5px 0px 0px;
  border: 1px solid #ededed;
  border-bottom: 0;
  background: #fbfbfb;
  box-sizing: border-box;
  width: calc(100% - 40px);
  @media (max-width: 767px) {
    width: 700px;
  }
`;

export const HeaderCell = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  span {
    display: inline-block;
    width: 280px;
    @media (max-width: 767px) {
      width: 190px;
    }
  }
  &:first-child {
    width: 230px;
    @media (max-width: 992px) {
      width: 210px;
    }
  }
  &:last-child {
    margin: 0 auto 0 125px;
  }
  @media (max-width: 1200px) {
    &:last-child {
      margin: 0 auto 0 155px;
    }
  }
  @media (max-width: 800px) {
    &:last-child {
      margin: 0 auto 0 40px;
    }
  }
  @media (max-width: 767px) {
    &:last-child {
      margin: 0 auto 0 -10px;
    }
  }
`;

export const ModalInputField = styled.div`
  position: relative;
  margin: 20px;
  svg {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 10;
  }
  input {
    padding-left: 50px;
    @media (max-width: 767px) {
      max-width: 100%;
      box-sizing: border-box;
    }
  }
`;

export const StyledActions = styled.div`
  margin: 0 20px;
`;

export const ModalButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  div {
    color: #4c4b9a;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const MemberDate = styled.div`
  width: 280px;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  span {
    display: inline-block;
    width: 100%;
  }
`;

export const NotFoundContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const NotFoundMessage = styled.span`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-weight: 700;
  @media (max-width: 767px) {
    font-size: 15px;
  }
`;
